// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay","modal":"Modal_modal","closeDialogButton":"Modal_closeDialogButton"};